import CancelIcon from '@material-ui/icons/Close';
import ToolbarItem from 'components/Toolbar/ToolbarItem';
const cancelIcon = React.createElement(CancelIcon, null);
// @ts-ignore
const ToolbarCancelItem = React.forwardRef((props, ref) => {
    return React.createElement(ToolbarItem, Object.assign({ main: true, ref: ref, icon: cancelIcon, text: "\u041E\u0442\u043C\u0435\u043D\u0430" }, props));
});
export default React.memo(ToolbarCancelItem);
